import {
  Autocomplete,
  Box,
  Checkbox,
  TextField,
  Typography,
} from "@mui/material";
import { ChartData } from "chart.js";
import { useMemo, useState } from "react";
interface Props {
  chartData: ChartData<"line">;
  setSelectedChartData: (data: ChartData<"line">) => void;
}

export const StructuresSelectbox = ({
  chartData,
  setSelectedChartData,
}: Props) => {
  const structureNames = useMemo<string[]>(() => {
    if (!chartData || chartData.datasets.length === 0) {
      return [];
    }

    return chartData.datasets.map((dataset) => dataset.label || "");
  }, [chartData]);

  const [selectedStructures, setSelectedStructures] = useState<string[]>([]);

  const handleSelectedStructuresChange = (
    _: React.SyntheticEvent,
    newValue: string[],
  ) => {
    if (newValue.length === 0) {
      setSelectedStructures([]);
      setSelectedChartData(chartData);
      return;
    }

    setSelectedStructures(newValue);
    const newChartDatasets = chartData.datasets.filter((dataset) => {
      if (dataset.label) {
        return newValue.includes(dataset.label);
      }
    });

    setSelectedChartData({
      datasets: newChartDatasets,
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 1, mb: 2 }}>
      <Typography sx={{ mb: 1 }}>Filter by: </Typography>
      <Autocomplete
        multiple
        size="small"
        limitTags={10}
        options={structureNames}
        value={selectedStructures}
        onChange={handleSelectedStructuresChange}
        disableCloseOnSelect
        disablePortal
        renderInput={(params) => <TextField {...params} label="Structures" />}
        renderOption={(props, option) => (
          <li {...props} key={option}>
            <Checkbox checked={selectedStructures.includes(option)} />
            {option}
          </li>
        )}
      />
    </Box>
  );
};

export default StructuresSelectbox;
